import commonStore from '../../store/commonStore.js';
import { osdetect } from '../../utils/general/deviceDetect';
import $ from 'jquery';
import { isNull, isEmpty, forEach, toUpper } from 'lodash';
import * as general from '../general/general';
import { RSCH_HTML_TRACKING_CONFIG } from '../../readership/trackingConfig';
import { IOffCuffCopyURLData } from '../../states/renditionStates';
import { cv_handleDownload } from '../../cvMobile/cvAppController';
import servicesConfig, { IServiceConfig } from './../../services/servicesConfig';
import services from '../../services/axios-services';
import { setTargetValue } from './../general/general';

export const openLink = (event: any, type: any) => {
    console.log('openLink === ' + type);
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    if (!type) return;
    if (type.toLowerCase() == 'download') {
        RSCH_HTML_TRACKING_CONFIG.trackSavePdfClick();
        if (general.isCVMobileApp()) {
            cv_handleDownload(getCopyHeadline());
        } else {
            handleDownload();
        }
    }
    else if (type.toLowerCase() == 'managesubscription') {
        RSCH_HTML_TRACKING_CONFIG.trackManageSubscriptionClick();
        goToSubscriptionCenter();
    }
    else if (type.toLowerCase() == 'feedback') {
        RSCH_HTML_TRACKING_CONFIG.trackShareTabFeedbackClick();
        const user = _HTML_RENDITION.errorReportUserType + ' ' + _HTML_RENDITION.user_id;
        const url = _HTML_RENDITION.productType === 'blog' ?
            getOffCuffUrl(_HTML_RENDITION.doc_id) :
            commonStore.getState().asyncStateReducer.copyURLData.copyURL;
        const body = encodeURIComponent(url) + ' ' + user;
        openMail("mailto:" + _HTML_RENDITION.feedback_email + "?subject=Citi Research feedback&body=" + body, event.target);
    }
    else if (type.toLowerCase() == 'feedback-footer') {
        RSCH_HTML_TRACKING_CONFIG.trackFeedbackClick();
        const user = _HTML_RENDITION.errorReportUserType + ' ' + _HTML_RENDITION.user_id;
        const body = encodeURIComponent(commonStore.getState().asyncStateReducer.copyURLData.copyURL) + ' ' + user;
        openMail("mailto:" + _HTML_RENDITION.feedback_email + "?subject=Citi Research feedback&body=" + body, event.target);
    }
    else if (type.toLowerCase() == 'help') {
        RSCH_HTML_TRACKING_CONFIG.trackHelpClick();
        openMail("mailto:" + _HTML_RENDITION.subscription_email + "?subject=", event.target);
    }
    else if (type.toLowerCase() == 'flipversion') {
        const flipVersionData = commonStore.getState().asyncStateReducer.flipVersionData;
        const _doc = general.getDocumentLink(flipVersionData.flipVersionId);
        general.showLoadMask();
        setTimeout(() => {
            general.hideLoadMask();
        }, 10000);        
        if (general.isAppInsideCViFrame() && !general.isAppInsideCVResearchUIiFrame()){
            general.changeCVUrl(_doc);
        }
        if (general.isBloomBerg()) {
          general.BloomBergExecution(_doc);
        } else if (general.isThirdPartyTokenAuthorization()) {
          general.tokenAuthorizationForThirdParty(_doc);
        } else {
          openInCurrentWindow(_doc);
        }
    }
    else if (type.toLowerCase() == 'backto') {
        RSCH_HTML_TRACKING_CONFIG.trackLeftMenuBackButtonClick();
        let backUrl;
        if (!_HTML_RENDITION.staticData || _HTML_RENDITION.staticData == 'null') {
            backUrl = general.getOpenDocumentLink(_HTML_RENDITION.parent_doc_id);
        } else {
            // Because HTML_RENDITION.parentDocData is "parent_doc_id=" + doc id, not "doc_id=" + doc_id.
            // Use Base64 to encode parent_doc_id.
            backUrl = general.getDocumentLink(Base64.encode('doc_id=' + _HTML_RENDITION.parent_doc_id));
        }
        general.showLoadMask();
        setTimeout(() => {
            general.hideLoadMask();
        }, 10000);        
        if (general.isAppInsideCViFrame() && !general.isAppInsideCVResearchUIiFrame() ){
            general.changeCVUrl(backUrl);
        }
        if (general.isBloomBerg()) {
            general.BloomBergExecution(backUrl);
        } else if (general.isThirdPartyTokenAuthorization()) {
            general.tokenAuthorizationForThirdParty(backUrl);
        }else {
            openInCurrentWindow(backUrl);
        }
    }
    else if (type.toLowerCase() == 'contactus') {
        RSCH_HTML_TRACKING_CONFIG.trackContactUsClick();
        openMail("mailto:" + _HTML_RENDITION.subscription_email + "?subject=", event.target);
    }
    else if (type.toLowerCase() == 'offlinereading') {
        RSCH_HTML_TRACKING_CONFIG.trackOfflineReading();
        handleOfflineReading();
    }
    else if (type.toLowerCase() == 'mediatermsofuse') {
        RSCH_HTML_TRACKING_CONFIG.trackMediaTermsOfUseClick();
        handleMediaTermsOfUse();
    }
    else if (type.toLowerCase() == 'privacystatementurl') {
        RSCH_HTML_TRACKING_CONFIG.trackPrivacyPolicyFooterClick();
        handlePrivacyStatementUrl();
    }

};

export const saveReportForOffline = () => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    general.showLoadMask();
    if (_HTML_RENDITION.isPPTOrLandscape) {
        // TBD
        // savePPTOrLandscape();
        return;
    }
    const isAllElementRendered = () => {
        if (commonStore.getState().commonStateReducer.fetchBodyJsonFinished) {
            clearInterval(renderAllContentWatcher);
            // TBD
            // getFinsumHtml();
        } else {
            // $scope.getMoreData();
        }
    };
    const renderAllContentWatcher = setInterval(isAllElementRendered, 200);
};

export const openViewReadingList = () => {
    let url = general.documentsPath_version + 'readingListIndex.html?ts=' + general.timestamp();
    if (general.isCPServer()) url = general.addCPServerParam(url);
    const userAgent = navigator ? navigator.userAgent.toLowerCase() : "other";
    if (userAgent.indexOf("chrome") > -1) {
        window.open(url, '_blank');
    } else {
        window.open(url, '_blank', 'width=800,height=700,top=200,left=500,resizable=yes,scrollbars=yes');
    }
    // TBD
    // inActivateMenuSelection();
};

const handleOfflineReading = () => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    if (_HTML_RENDITION.isEntitled('OFFLINE_READING')) {
        let url = digiDocsUrl('savepdf');

        if (general.isChromeFrame()) {
            url += "&no_wm=true";
        }
        const width = ($(window).width() || 0) * 0.9;
        const height = ($(window).height() || 0) * 0.9;
        openOfflineReadingListUrl(url, width, height);
    }
};

const openOfflineReadingListUrl = (url: string, width: number, height: number) => {
    if (general.isCVMobileApp()) {
        window.location.href = 'cvopenexternallink:' + url;
    } else {
        window.open(url, "PDF", "resizable=yes, top=0, left=0, width=" + width + ", height=" + height);
    }
};

const goToSubscriptionCenter = () => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    const menuCode = commonStore.getState().commonStateReducer.menuCode;
    if (_HTML_RENDITION.new_subscription_url != 'true') {
        openInNewWindow("/cvr/eppublic/citi_research_subscription/subscription.action/" + _HTML_RENDITION.encoded_user_login_string);
        return;
    }

    const targetUrl = `/icg-subscriptions/akpublic/index.html?platformId=${_HTML_RENDITION.platform}#/currentSubscriptions`;
    const urlWithCVFrame = general.getCVFrameUrl(menuCode, _HTML_RENDITION.html_origin + targetUrl, 'sub_center');
    window.open(urlWithCVFrame, setTargetValue(urlWithCVFrame));
};

export const handleDownload = () => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    const docHeaderJsonData = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    if (window.externalHost) {
        const downloadWindow = openInNewWindow("/rendition/eppublic/uiservices/print?doc_id=" + _HTML_RENDITION.doc_id + "&type=download&isJP=" + docHeaderJsonData.metadata.isJP);
        setTimeout(() => {
            downloadWindow && downloadWindow.close();
        }, 20000);
    } else {
        openInCurrentWindow("/rendition/eppublic/uiservices/print?doc_id=" + _HTML_RENDITION.doc_id + "&type=download&isJP=" + docHeaderJsonData.metadata.isJP);
    }
};

const handlePrivacyStatementUrl = () => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    if (_HTML_RENDITION?.privacyStatementUrl) {
        return window.open(_HTML_RENDITION.privacyStatementUrl, '_blank');
    }
};

const handleMediaTermsOfUse = () => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    return window.open(_HTML_RENDITION.mediaTermsOfUseLink, '_blank');
};

const openInCurrentWindow = (link: string) => {
    window.location.href = link;
};

const openInNewWindow = (link: string) => {
    return window.open(link, '_blank');
};

const openMail = (link: string, ele: any) => {
    if (openMailInSumsungTab3()) {
        return;
    }
    $(ele).removeAttr('href');

    if (typeof window.PORTAL == 'undefined') {
        window.location.href = link;
    } else {
        const userAgent = navigator ? navigator.userAgent.toLowerCase() : "other";
        if (userAgent.indexOf("chrome") < 0 || window.externalHost) {
            window.location.href = link;
        } else {
            const mailWindow = window.open(link, '_blank');
            setTimeout(() => {
                mailWindow && mailWindow.close();
            }, 100);
        }
    }
};

// Fix JIRA#163778-1657 [Device] Click "Feedback" or "Contact Us" or "Help"-> The email "To" field is null and subject is empty
const openMailInSumsungTab3 = () => {
    if (!osdetect.detectSamsungTab3Tablet()) {
        return false;
    }
    const sumsungTab3Version = osdetect.detectAndroidTabletVersion();
    const isHigherVersion = sumsungTab3Version && parseFloat(sumsungTab3Version) > 4.3;
    if (isHigherVersion) {
        return true;
    }
    return false;
};

const getOffCuffUrl = (currentDocId: string) => {
    let offCuffUrl = '';
    forEach(
        commonStore.getState().offCuffListStateReducer.offCuffCopyURLData,
        (doc: IOffCuffCopyURLData) => {
            if (doc.docId === currentDocId) {
                offCuffUrl = doc.data;
            }
        });
    return offCuffUrl;
};

export const deviceTypeFunc = () => {
    let device_type = 'DESKTOP';
    try {
        if (osdetect && osdetect.detectSmartPhone())
            device_type = 'MOBILE';
        else if (osdetect && osdetect.detectTablet())
            device_type = 'TABLET';
    } catch (e) {
        return device_type;
    }
    return device_type;
};

export const openNewTestPage = () => {
    RSCH_HTML_TRACKING_CONFIG.trackCompatibilityTestClick();
    window.open("/rendition/eppublic/service/diagnostic/compatibilityTest");
};

export const digiDocsUrl = (viewOption?: string) => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    let url = _HTML_RENDITION.digidocs_url;
    if (general.isCPServer())
        url = general.addCPServerParam(url);

    const source_id = isNull(_HTML_RENDITION.parent_doc_id) ? 0 : _HTML_RENDITION.parent_doc_id;
    const tmpUrl = `docid=${_HTML_RENDITION.doc_id}&deviceType=${deviceTypeFunc()}&pdfFileName=${_HTML_RENDITION.pdf_file_name}&platform=${_HTML_RENDITION.platform}&source_id=${source_id}&viewOption=${viewOption}&channel=${_HTML_RENDITION.channel}&subChannel=${_HTML_RENDITION.sub_channel}`;
    const encodedUrl = btoa(tmpUrl);
    url = url + "?data=" + encodedUrl;
    return url;
};

export const printUrl = async (isJP: boolean) => {
    let url = '/rendition/eppublic/uiservices/print?';
    if (general.isTimedLinkAvailable && general.getLinkId()){
        url = '/rendition/eppublic/service/print?linkId=' + general.getLinkId() + '&';
    }
    url = url + 'doc_id=' + commonStore.getState().asyncStateReducer.initialData.doc_id
        + '&type=print&isJP=' + isJP;
    if (general.isCPServer())
        url = general.addCPServerParam(url);
    if (general.isThirdPartyTokenAuthorization()) {
        general.getRequestToken().then((token: any) => {
            url = general.addParam(url, '__epftoken', token.access_token);
        });
    }
    return url;
};

export const getCopyHeadline = (offTheCuffTitle?: string) => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;

    if (
        (window.HTML_RENDITION.isBlogPrintMode || window.HTML_RENDITION.isOffCuffList) &&
        window.HTML_RENDITION.copyHeadline == offTheCuffTitle
    ) {
        return window.HTML_RENDITION.copyHeadline;
    }
    if (!window.HTML_RENDITION.isBlogPrintMode &&
        !window.HTML_RENDITION.isOffCuffList &&
        window.HTML_RENDITION.copyHeadline
    ) {
        return window.HTML_RENDITION.copyHeadline;
    }
    let copyHeadline = null;
    const productType = _HTML_RENDITION.productType;
    const docHeaderJson = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    if (productType == 'globaliser') {
        copyHeadline = docHeaderJson.metadata.productBranding + ' - ' + docHeaderJson.metadata.titleText;
    } else if (productType == 'anr' || productType == 'company' || productType == 'credit') {
        copyHeadline = docHeaderJson.metadata.issuer + ' - ' + docHeaderJson.metadata.titleText;
    } else if (window.HTML_RENDITION.isBlogPrintMode || window.HTML_RENDITION.isOffCuffList) {
        copyHeadline = offTheCuffTitle;
    } else {
        copyHeadline = docHeaderJson.metadata.researchArea + ' - ' + docHeaderJson.metadata.titleText;
    }
    return window.HTML_RENDITION.copyHeadline = copyHeadline;
};

const setBackToParentParams = (viewMoreFromText: string, backToText: string, parentProduct: string) => {
    const docHeaderJson = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    docHeaderJson.i18n_dynamic = {};
    docHeaderJson.i18n_dynamic.viewMoreFromText = viewMoreFromText;
    docHeaderJson.i18n_dynamic.backToText = backToText;
    docHeaderJson.i18n_dynamic.parentProduct = parentProduct;
};

export const urlCopyFunc = (copyUrlOrigon: string, removeExtraPathBln: boolean) =>  {
    return new Promise((resolve, reject) => {
        const serviceDetail: IServiceConfig = servicesConfig.GET_COPY_URL;
        if (removeExtraPathBln) {
            serviceDetail.url_parameter = [
                'copyURL=' + encodeURIComponent(copyUrlOrigon),
                'removeExtraPath=true',
            ];
        } else {
            serviceDetail.url_parameter = [
                'copyURL=' + encodeURIComponent(copyUrlOrigon),
            ];
        }

        services.getData(serviceDetail, {}, '')
        .then((resp: any) => {
            if (resp.status == 200) {
                const copyURL =  resp.data?.copyURL;
                if (!isEmpty(copyURL)) {
                    resolve(copyURL);
                } else {
                    reject(new Error("GET_COPY_URL::Service No ShortUrl Data"));
                }
            }
        }).catch((error: any) => {
            console.error(error);
            reject(new Error("GET_COPY_URL:: Service Internal Error"));
         });
      });
};

export const showBackToParent = (i18n: any) => {
    const _HTML_RENDITION = commonStore.getState().asyncStateReducer.initialData;
    const parentProductType = _HTML_RENDITION.urlParameters.parentProduct;
    const isPoint = _HTML_RENDITION.urlParameters.isPoint;

    if (parentProductType == 'Globaliser'){
        setBackToParentParams(i18n.viewMoreFromGlobaliser, i18n.backToGlobaliser, parentProductType);
        return true;
    }
    if (parentProductType == 'Roundup'){
        setBackToParentParams(i18n.viewMoreFromRoundup, i18n.backToRoundup, parentProductType);
        return true;
    }
    if (isPoint == 'true' || parentProductType){
        setBackToParentParams(i18n.viewMoreFromPoint, i18n.backToPoint, 'ThePoint');
        return true;
    }
    return false;
};
